
import React from 'react';
import { useTheme } from '../../context/ColorContext';
import { Link } from 'react-router-dom';

const Footer = () => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    return (
        <footer className={`fixed bottom-0 left-0 right-0 z-[60] py-3 border-t backdrop-blur-xl ${isDark ? 'bg-black/85 border-white/10' : 'bg-white/90 border-black/10'} pointer-events-none shadow-[0_-4px_20px_rgba(0,0,0,0.08)]`}>
            <div className="container mx-auto px-4 md:px-6 flex justify-center items-center gap-3 md:gap-6 pointer-events-auto">
                <Link
                    to="/kvkk"
                    className={`text-[8px] sm:text-[9px] md:text-[10px] font-black uppercase tracking-[0.15em] transition-all hover:text-[#5AA668] whitespace-nowrap ${isDark ? 'text-white/70' : 'text-slate-700'}`}
                >
                    KVKK
                </Link>
                <div className={`w-1 h-1 rounded-full shrink-0 ${isDark ? 'bg-white/30' : 'bg-black/20'}`}></div>
                <Link
                    to="/cerez-politikasi"
                    className={`text-[8px] sm:text-[9px] md:text-[10px] font-black uppercase tracking-[0.15em] transition-all hover:text-[#5AA668] whitespace-nowrap ${isDark ? 'text-white/70' : 'text-slate-700'}`}
                >
                    ÇEREZ POLİTİKASI
                </Link>
                <div className={`w-1 h-1 rounded-full shrink-0 ${isDark ? 'bg-white/30' : 'bg-black/20'}`}></div>
                <span className={`text-[8px] sm:text-[9px] md:text-[10px] font-black uppercase tracking-[0.15em] whitespace-nowrap ${isDark ? 'text-white/50' : 'text-slate-500'}`}>
                    © 2026 DÜFA
                </span>
            </div>
        </footer>
    );
};

export default Footer;
